export default {
    MakePDF(student, control, coursework, practice, book_number, state) {
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        };

        function buildTableBody(head, data, columns, prefix) {
            var body = [];
            var dataHeadRow = [];
            var n = 1;

            if (prefix != []) {
                body.push(prefix);
            }

            head.forEach(function (column) {
                dataHeadRow.push(
                    {text: column.toString(), style: 'eightNormal', alignment: 'center'});
            });

            body.push(dataHeadRow);

            data.forEach(function (row) {
                if (row.mark !== 'Неудовлетворительно' && row.mark !== 'Не явился' && row.mark !== 'Не зачтено' ){
                    var dataRow = [];

                    columns.forEach(function (column) {
                        dataRow.push({text: row[column].toString(), style: 'eightItalics', alignment: 'center'});
                    })

                    body.push(dataRow);
                    n = n + 1;
                }
            });

            while (n < 6) {
                var zero = [];
                head.forEach(function (column) {
                    zero.push(
                        {text: '', style: 'eightNormal', alignment: 'center'});
                });
                body.push(zero);
                n = n + 1;
            }


            return body;
        }

        function buildTableBody2(head, data, columns) {
            var body = [];
            var dataHeadRow = [];
            var n = 1;

            head.forEach(function (column) {
                dataHeadRow.push(
                    {text: column.toString(), style: 'tenBold', alignment: 'center'});
            });

            body.push(dataHeadRow);

            data.forEach(function (row) {
                if (row.mark !== 'Неудовлетворительно' && row.mark !== 'Не явился' && row.mark !== 'Не зачтено' ){
                    var dataRow = [];

                    columns.forEach(function (column) {
                        dataRow.push({text: row[column].toString(), style: 'tenItalics', alignment: 'center'});
                    })

                    body.push(dataRow);
                    n = n + 1;
                }
            });

            while (n < 6) {
                var zero = [];
                head.forEach(function (column) {
                    zero.push(
                        {text: '', style: 'eightNormal', alignment: 'center'});
                });
                body.push(zero);
                n = n + 1;
            }


            return body;
        }

        let titlePage = {
            info: {
                title: `АмГУ, зачетная книжка ${student.surname} ${student.name} ${student.patronymic} ${student.group[state]}`,
                author: 'ЦИиОТ, АмГУ',
                subject: '',
                keywords: ''
            },

            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [10, 10, 30, 30],

            header: [],
            footer: [],
            content: [
                {
                    style: 'tableExample',
                    table: {

                        widths: [48, 1, 2, 14, 50, 75, 150],
                        heights: ['auto', 'auto', 'auto', 10, 'auto', 'auto', 'auto', 'auto', 12],
                        body: [
                            [{
                                text: 'МИНОБРНАУКИ РОССИИ',
                                style: 'eightBold',
                                colSpan: 7,
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {}, {}, {}, {}, {}, {}],
                            [{
                                text: 'Федеральное государственное бюджетное образовательное учреждение высшего образования',
                                style: 'sevenBold',
                                colSpan: 7,
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {}, {}, {}, {}, {}, {}],
                            [{
                                text: '«Амурский государственный университет»',
                                style: 'eightBold',
                                colSpan: 7,
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {}, {}, {}, {}, {}, {}],
                            [{
                                text: '(ФГБОУ ВО «АмГУ»)',
                                style: 'eightBold',
                                colSpan: 7,
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {}, {}, {}, {}, {}, {}],
                            [{
                                text: `Зачетная книжка № ${book_number}`,
                                style: 'fourteenBold',
                                colSpan: 7,
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {}, {}, {}, {}, {}, {}],
                            [{
                                text: 'Фамилия',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: student.surname,
                                style: 'tenItalics',
                                colSpan: 6,
                                border: [false, false, false, true]
                            }, {}, {}, {}, {}, {}],
                            [{
                                text: 'имя, отчество',
                                style: 'twelveNormal',
                                colSpan: 3,
                                border: [false, false, false, false]
                            }, {}, {}, {
                                text: `${student.name}  ${student.patronymic}`,
                                style: 'tenItalics',
                                colSpan: 4,
                                border: [false, false, false, true]
                            }, {}, {}, {}],
                            [{
                                text: 'Код, направление подготовки (специальность)',
                                style: 'twelveNormal',
                                colSpan: 6,
                                border: [false, false, false, false]
                            }, {}, {}, {}, {}, {}, {
                                text: '',
                                style: 'eightNormal',
                                border: [false, false, false, true]
                            }],
                            [{
                                text: student.speciality_name[state],
                                style: 'tenItalics',
                                colSpan: 7,
                                border: [false, false, false, true]
                            }, {}, {}, {}, {}, {}, {}],
                            [{
                                text: 'Факультет',
                                style: 'twelveNormal',
                                colSpan: 2,
                                border: [false, false, false, false]
                            }, {}, {
                                text: student.facility[state],
                                style: 'tenItalics',
                                colSpan: 5,
                                border: [false, false, false, true]
                            }, {}, {}, {}, {}],
                            [{
                                text: 'Проректор по учебной работе',
                                style: 'twelveNormal',
                                colSpan: 5,
                                border: [false, false, false, false]
                            }, {}, {}, {}, {}, {
                                text: 'Лейфа Андрей Васильевич',
                                style: 'tenItalics',
                                colSpan: 2,
                                border: [false, false, false, true]
                            }, {}],
                            [{
                                text: '',
                                style: 'fiveBold',
                                colSpan: 5,
                                border: [false, false, false, false]
                            }, {}, {}, {}, {}, {
                                text: '(фамилия, имя, отчество)',
                                style: 'fiveBold',
                                colSpan: 2,
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {}],
                            [{
                                text: 'Декан факультета',
                                style: 'twelveNormal',
                                colSpan: 4,
                                border: [false, false, false, false]
                            }, {}, {}, {}, {
                                text: student.decan[state],
                                style: 'tenItalics',
                                colSpan: 3,
                                border: [false, false, false, true]
                            }, {}, {}],
                            [{
                                text: '',
                                style: 'fiveBold',
                                colSpan: 4,
                                border: [false, false, false, false]
                            }, {}, {}, {}, {
                                text: '(фамилия, имя, отчество)',
                                style: 'fiveBold',
                                colSpan: 3,
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {}, {}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '1-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ПЕРВЫЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Первый семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Первый семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        heights: [15],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '2-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ПЕРВЫЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Второй семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Второй семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '3-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ВТОРОЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Третий семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Третий семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        heights: [15],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '4-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ВТОРОЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Четвертый семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Четвертый семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '5-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ТРЕТИЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Пятый семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Пятый семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        heights: [15],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '6-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ТРЕТИЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Шестой семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Шестой семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '7-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ЧЕТВЕРТЫЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Седьмой семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Седьмой семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        heights: [15],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '8-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ЧЕТВЕРТЫЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Восьмой семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Восьмой семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '9-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ПЯТЫЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Девятый семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Девятый семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        heights: [15],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '10-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ПЯТЫЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Десятый семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Десятый семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '11-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ШЕСТОЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Одиннадцатый семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Одиннадцатый семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        heights: [15],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '12-й семестр ',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ШЕСТОЙ                 КУРС ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Двенадцатый семестр'].exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control['Двенадцатый семестр'].test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'ФАКУЛЬТАТИВНЫЕ              ДИСЦИПЛИНЫ',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    columns: [
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 15, 15, 15, 15, 15, 15, 15, 15],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control.Факультативы.exam,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (экзамены)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                        {
                            width: '50%',
                            style: 'tableExample',
                            table: {

                                widths: [10, 100, 35, 40, 40, 60, 60],
                                heights: ['auto', 10, 10, 10, 10, 10, 10, 10, 10],
                                body: buildTableBody(
                                    ['№', 'Наименование дисциплины (модуля), раздела', 'Общее кол-во час./з.ед.', 'Оценка', 'Дата сдачи экзамена', 'Подпись преподавателя', 'Фамилия преподавателя'],
                                    control.Факультативы.test,
                                    ['num', 'name', 'hours', 'mark', 'date', 'teacher', 'teacher'],
                                    [{
                                        text: 'Результаты промежуточной аттестации (зачеты)',
                                        style: 'tenNormal',
                                        colSpan: 7,
                                        alignment: 'center',
                                        border: [false, false, false, false]
                                    }, {}, {}, {}, {}, {}, {}]
                                )
                            }
                        },
                    ],
                    columnGap: 30
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'КУРСОВЫЕ РАБОТЫ (ПРОЕКТЫ)',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [10, 130, 230, 55, 60, 55, 100, 100],
                        heights: ['auto', 20, 20, 20, 20, 20, 20, 20, 20],
                        body: buildTableBody2(
                            ['№', 'Наименование дисциплины (модуля)', 'Тема курсовой работы (проекта)', 'Семестр', 'Оценка', 'Дата сдачи', 'Подпись преподавателя', 'Фамилия преподавателя'],
                            coursework,
                            ['num', 'name', 'theme', 'term', 'mark', 'date', 'teacher', 'teacher'],
                        )
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [250, 280, 270],
                        heights: ['auto'],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                colSpan: 3,
                                pageBreak: 'before',
                                border: [false, false, false, false]
                            }, {}, {}],
                            [{text: '', style: 'twelveNormal', border: [false, false, false, false]}, {
                                text: 'ПРАКТИКА',
                                style: 'twelveNormal',
                                alignment: 'center',
                                border: [false, false, false, false]
                            }, {
                                text: `${student.surname} ${student.name} ${student.patronymic}`,
                                style: 'tenItalics',
                                alignment: 'right',
                                border: [false, false, false, false]
                            }],
                        ]
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [130, 55, 90, 60, 85, 40, 85, 50, 50, 85],
                        heights: ['auto', 20, 20, 20, 20, 20, 20, 20, 20],
                        body: buildTableBody2(
                            ['Наименование вида практики', 'Семестр', 'Место проведения практики', 'В качестве кого работал (должность)', 'Ф.И.О. руководителя практики от предприятия', 'Общее кол-во час/з. ед.', 'Фамилия руководителя практики от университета', 'Оценка по итогам аттестации', 'Дата проведения аттестации', 'Фамилия преподавателя'],
                            practice,
                            ['name', 'term', 'organization', 'position', 'leader', 'hours', 'teacher', 'mark', 'date', 'teacher']
                        )
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [400, 100, 200],
                        body: [
                            [{
                                text: '',
                                style: 'twelveNormal',
                                border: [false, false, false, false]
                            }, {
                                text: 'Декан факультета',
                                style: 'tenNormal',
                                border: [false, false, false, false]
                            }, {text: student.decan[state], style: 'tenItalics', border: [false, false, false, true]}],
                        ]
                    }
                },
            ],

            styles: {
                fiveNormal: {
                    fontSize: 5,
                    font: 'Times',
                    bold: false
                },
                fiveBold: {
                    fontSize: 5,
                    font: 'Times',
                    bold: true,
                    lineHeight: 0.3
                },
                sevenBold: {
                    fontSize: 7,
                    font: 'Times',
                    bold: true,
                    lineHeight: 0.5
                },
                eightNormal: {
                    fontSize: 8,
                    font: 'Times',
                    bold: false
                },
                eightBold: {
                    fontSize: 8,
                    font: 'Times',
                    bold: true,
                    lineHeight: 0.5
                },
                eightItalics: {
                    fontSize: 8,
                    font: 'Times',
                    bold: false,
                    italics: true
                },
                nineNormal: {
                    fontSize: 9,
                    font: 'Times',
                    bold: false
                },
                tenBoldItalics: {
                    fontSize: 10,
                    font: 'Times',
                    bold: false,
                    italics: true
                },
                tenBold: {
                    fontSize: 10,
                    font: 'Times',
                    bold: true,
                    italics: false
                },
                tenItalics: {
                    fontSize: 10.5,
                    font: 'Times',
                    bold: false,
                    italics: true
                },
                tenNormal: {
                    fontSize: 10.5,
                    font: 'Times',
                    bold: false
                },
                twelveNormal: {
                    fontSize: 11,
                    font: 'Times',
                    bold: false,
                    lineHeight: 1.2
                },
                fourteenBold: {
                    fontSize: 14,
                    font: 'Times',
                    bold: true
                }
            }
        };

        pdfMake.createPdf(titlePage).download(`Зачетная книжки книжка ${student.surname} ${student.name} ${student.patronymic} ${student.group[state]}.pdf`);
    }
}